export const globalPromotionsManager = {
  header: {
    title: "Promotions Manager",
    description:
      "Create and manage account-wide stay promotions. They will be available for any of your properties (apartments and hotels).",
  },

  toolbar: {
    info: "Promotions created here can be activated from the <strong>Promotions</strong> tab of each property.",
    newPromotion: "New promotion",
  },

  loading: "Loading promotions...",
  close: "Close",
  cancel: "Cancel",
  noLimit: "No limit",

  status: {
    active: "Active",
    paused: "Paused",
  },

  card: {
    stay: "Stay",
    discount: "Discount",
    validity: "Validity",
    edit: "Edit",
    delete: "Delete",
  },

  nights: {
    range: "{min} – {max} nights",
    min: "{min}+ nights",
  },

  discount: {
    fixed: "{value} (fixed)",
  },

  empty: {
    title: "No promotions created",
    description:
      "Create promotions to encourage longer stays. You can activate them on each property from its direct bookings settings.",
    create: "Create first promotion",
  },

  form: {
    editTitle: "Edit promotion",
    createTitle: "New promotion",
    nameLabel: "Promotion name",
    namePlaceholder: "e.g. 7-night discount, Weekly deal",
    minNights: "Minimum nights",
    maxNights: "Maximum nights",
    optional: "(optional)",
    noLimitPlaceholder: "No limit",
    discountType: "Discount type",
    percentage: "Percentage",
    fixedAmount: "Fixed amount",
    discountValue: "Discount value",
    amountSuffix: "amount",
    validFrom: "Valid from",
    validTo: "Valid until",
    activateNow: "Activate promotion immediately",
    propertiesLabel: "Properties where it will be available",
    selectAll: "Select all",
    propertiesHelper:
      "Configuration records will be created for the selected properties.",
    infoBox:
      "You can later adjust the badge, order and behavior from the <strong>Promotions</strong> tab of each property.",
    saving: "Saving...",
    update: "Update",
    create: "Create promotion",
  },

  deleteModal: {
    title: "Delete promotion",
    warningStrong: "This action cannot be undone.",
    warningBefore: "You are about to delete the promotion",
    warningAfter: ". It will no longer be available on any property.",
    confirmLabel: "Type the exact name to confirm:",
    confirmPlaceholder: "Type the promotion name",
    deleting: "Deleting...",
    confirmDelete: "Delete permanently",
  },

  toasts: {
    loadError: "Could not load promotions.",
    nameRequired: "Enter a name for the promotion",
    minNightsWarning: "Minimum nights must be at least 1",
    discountValueWarning: "The discount value must be greater than 0",
    selectProperty: "Select at least one property",
    updated: "Promotion updated",
    created: "Promotion created successfully",
    saveFailed: "Could not save",
    saveError: "Error saving the promotion",
    deleted: "Promotion deleted",
    deleteFailed: "Could not delete",
    deleteError: "Error deleting",
  },
};
